<template>
  <div class="home-bottom-section">
    <!-- 专题横幅区域 -->
    <div class="banner-section">
      <div class="banner-item special-topic" >
        <span class="banner-text">专题</span>
        <div class="arrow-shape"></div>
      </div>
      
      <!-- <a class="banner-item party-spirit" v-for="val in specialList" :key="val.pic" :href="val.url" target="_blank">
        <img :src="val.pic" alt="">
      </a> -->

      <div class="banner-item party-spirit" v-for="(val,index) in specialList" :key="index" @click="goSpecial(val,index)">
        <img :src="val.pic" alt="">
      </div>
     
    </div>

    <!-- 资源链接区域 -->
    <div class="resource-section">
      <div class="section-header">
        <div class="header-bar"></div>
        <h3 class="section-title">资源链接</h3>
      
      </div>
      <div class="resource-grid">
        <a class="resource-item" href="https://basic.smartedu.cn/" target="_blank">
          <div class="resource-icon">⚙️⭐</div>
          <span class="resource-text">国家智慧平台</span>
        </a>
        <a class="resource-item"  href="https://eduncet.zonekey.com.cn/edu_cloud/login/user?siteIdentify=zonekey" target="_blank">
          <div class="resource-icon">📊</div>
          <span class="resource-text">智能研修平台</span>
        </a>
        <a class="resource-item" href="https://jsxt.lnen.cn/" target="_blank">
          <div class="resource-icon">👤📄</div>
          <span class="resource-text">教师管理系统</span>
        </a>
        <a class="resource-item"  href="https://www.youku.com/profile/index/?spm=a2h0c.8166622.PhoneSokuUgc_18.3&uid=UMTk4NzA3MDgw" target="_blank">
          <div class="resource-icon">🔍</div>
          <span class="resource-text">校园电视台</span>
        </a>
        <a class="resource-item"  href="https://sso.zxxk.com/login?service=https%3A%2F%2Fss.xkw.com%2Fcallback%3Fclient_name%3DCasClient" target="_blank">
          <div class="resource-icon">📋</div>
          <span class="resource-text">学科网</span>
        </a>
        <a class="resource-item"  href="http://www.aseduzy.com/index.do" target="_blank">
          <div class="resource-icon">👥📈</div>
          <span class="resource-text">鞍山资源平台</span>
        </a>
        <a class="resource-item"  href="https://www.lnjyy.cn:20030/cms-portal/ysyykResource.html" target="_blank">
          <div class="resource-icon">📖</div>
          <span class="resource-text">辽宁资源平台</span>
        </a>
        <a class="resource-item"  href="http://www.aslibrary.com/" target="_blank">
          <div class="resource-icon">📚</div>
          <span class="resource-text">数字图书馆</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBottomTu',
  data(){
    return{
      specialList:[
        {
           pic: require('@/assets/img/special1.jpg'),
           url:'https://www.12371.cn/special/20jszqh/'
        },
          {
           pic: require('@/assets/img/special2.jpg'),
           url:'https://www.12371.cn/djxx/'
        },
          {
           pic: require('@/assets/img/special3.jpg'),
           url:'https://www.12371.cn/special/20jszqh/'
        },
          {
           pic: require('@/assets/img/special4.jpg'),
           url:'https://www.12371.cn/special/20jszqh/'
        },
          {
           pic: require('@/assets/img/special5.jpg'),
           url:'https://www.12371.cn/special/20jszqh/'
        },
          {
           pic: require('@/assets/img/special6.jpg'),
           url:''
        },
       
      ]
    }
  },
  methods: {
    goSpecial(val,index) {
      // this.$router.push('/videoSpecial');
      if(index == 0 || index == 1){
        window.open(val.url, '_blank');
      }
    },
   
    goToResource(type) {
      // 跳转到对应的资源链接
      console.log('跳转到资源:', type);
    }
  }
}
</script>

<style scoped>
.home-bottom-section {
  max-width: 1200px;
  margin: 0 auto;

}

/* 专题横幅区域 */
.banner-section {
  display: flex;

  margin-bottom: 30px;
  flex-wrap: wrap;
}

.banner-item {
  position: relative;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;

  img{
    display: block;
    width: 152px;
    height: 48px;
  }
}


/* 专题按钮 */
.special-topic {
  background: linear-gradient(135deg, #007bff, #0056b3);
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 120px;
  color: #fff;
  font-size: 14px;
  margin-right:8px;
}

.arrow-shape {
  width: 0;
  height: 0;
  border-left: 15px solid #fff;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  margin-left: 5px;
}



.stars {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 12px;
}

/* 资源链接区域 */
.resource-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.header-bar {
  width: 4px;
  height: 30px;
  background: #28a745;
  margin-right: 15px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #28a745;
}

.more-link {
  position: absolute;
  right: 0;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.more-link:hover {
  background: #f8f9fa;
  color: #333;
}

/* 资源网格 */
.resource-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 15px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.resource-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 5px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  min-height: 100px;
  justify-content: center;
  flex-shrink: 0;
  min-width: 120px;
}

.resource-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.resource-icon {
  font-size: 24px;
  margin-bottom: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resource-text {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  line-height: 1.3;
  text-align: center;
}

/* 资源项颜色 */
.resource-item:nth-child(1) {
  background: linear-gradient(135deg, #007bff, #0056b3);
}

.resource-item:nth-child(2) {
  background: linear-gradient(135deg, #17a2b8, #138496);
}

.resource-item:nth-child(3) {
  background: linear-gradient(135deg, #28a745, #1e7e34);
}

.resource-item:nth-child(4) {
  background: linear-gradient(135deg, #20c997, #17a085);
}

.resource-item:nth-child(5) {
  background: linear-gradient(135deg, #fd7e14, #e55a00);
}

.resource-item:nth-child(6) {
  background: linear-gradient(135deg, #ffc107, #e0a800);
}

.resource-item:nth-child(7) {
  background: linear-gradient(135deg, #6f42c1, #5a32a3);
}

.resource-item:nth-child(8) {
  background: linear-gradient(135deg, #007bff, #0056b3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-section {
    flex-direction: column;
    gap: 10px;
  }
  
  .banner-item {
    width: 100%;
    justify-content: center;
  }
  
  .resource-grid {
    gap: 10px;
  }
  
  .resource-item {
    padding: 15px 10px;
    min-height: 80px;
  }
  
  .resource-text {
    font-size: 12px;
  }
  
  .resource-icon {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .home-bottom-section {
    padding: 10px;
  }
  
  .banner-item {
    padding: 12px 15px;
    min-height: 50px;
  }
  
  .banner-text {
    font-size: 14px;
  }
  
  .resource-grid {
    gap: 8px;
  }
  
  .resource-item {
    padding: 12px 8px;
    min-height: 70px;
  }
  
  .resource-text {
    font-size: 11px;
  }
  
  .resource-icon {
    font-size: 18px;
  }
}
</style>
